
import React from 'react';
import { format } from 'date-fns';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Subscription } from '@/types/subscription';

interface OnboardingDetailsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  subscription: Subscription | null;
}

const OnboardingDetailsDialog: React.FC<OnboardingDetailsDialogProps> = ({
  open,
  onOpenChange,
  subscription
}) => {
  if (!subscription) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white shadow-lg border border-gray-200">
        <DialogHeader>
          <DialogTitle>Customer Onboarding Details</DialogTitle>
          <DialogDescription>
            Onboarding information for {subscription.businessName}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 bg-gray-50 p-4 rounded-lg">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-muted-foreground">Business Name</Label>
              <p className="font-medium">{subscription.businessName}</p>
            </div>
            <div>
              <Label className="text-muted-foreground">Subscription Status</Label>
              <p className="font-medium">{subscription.status}</p>
            </div>
            <div>
              <Label className="text-muted-foreground">Onboarding Email Sent</Label>
              <p className="font-medium">
                {subscription.onboardingEmailSent ? 'Yes' : 'No'}
              </p>
            </div>
            {subscription.onboardingEmailSent && subscription.onboardingEmailDate && (
              <div>
                <Label className="text-muted-foreground">Email Sent Date</Label>
                <p className="font-medium">
                  {format(subscription.onboardingEmailDate, 'MMM d, yyyy')}
                </p>
              </div>
            )}
            <div>
              <Label className="text-muted-foreground">First Login</Label>
              <p className="font-medium">
                {subscription.firstLoginDate 
                  ? format(subscription.firstLoginDate, 'MMM d, yyyy')
                  : 'Not logged in yet'
                }
              </p>
            </div>
            {subscription.status === 'trial' && subscription.trialEndDate && (
              <div>
                <Label className="text-muted-foreground">Trial Ends</Label>
                <p className="font-medium">
                  {format(subscription.trialEndDate, 'MMM d, yyyy')}
                </p>
              </div>
            )}
          </div>
          
          <div className="border-t pt-4">
            <Button variant="outline" className="w-full" onClick={() => onOpenChange(false)}>
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OnboardingDetailsDialog;
